import { h, Component } from 'preact';
// import Store from 'store/store';
// import * as actions from 'store/actions';
import { joinClasses } from 'utils/utils';
import HTML from 'components/core/html/html.js';
import pure from 'utils/pure';
import s from 'components/shared/reveal/reveal.sss';


export default @pure class Reveal extends Component {

	constructor(props) {
		super(props);
		this.trackClicks = this.trackClicks.bind(this);
	}

	trackClicks() {
		// No. This is for every reveal, including the calendar reminder, not just share
		// Added to social.js
		// Store.emit(actions.CLICKED_SHARE, true);
	}

	render(props) {
		const {
			linkList,
			revealClass,
			revealWrapper,
			wrapperClass,
			buttonText,
			sourceContainer,
			shouldTransform = true,
			titleClass,
			show,
			customPrompt
		} = props;

		// NOTE: childwrapper should be a ul instead of div but because of bug in preact we changed it to div
		const newRevealClass = joinClasses(revealClass, sourceContainer && s[sourceContainer + 'Container']);

		let prompt;
		if (buttonText) {
			prompt = <HTML tag="div" class={s.inner}>{buttonText}</HTML>;
		}

		if (customPrompt) {
			prompt = <div class={s.inner}>{customPrompt}</div>;
		}

		const transformClass = shouldTransform ? s.transform : s.dontTransform;

		return (
			<div class={newRevealClass}>
				<div class={joinClasses(revealWrapper || s.revealWrapper, show && s.show, transformClass)}>
					<div class={joinClasses(s.prompt, titleClass)}>
						{prompt}
					</div>
					<div class={joinClasses(s.childWrapper, wrapperClass)} onClick={this.trackClicks}>
						{linkList}
					</div>
				</div>
			</div>
		);
	}

}
